export class RhdICDCodesClass {
  constructor(
    public O360110 = false,
    public O360120 = false,
    public O360130 = false,
    public Z3182 = false,
    public otherRhdICDCodes = "",
  ) {}
}
